module.exports = __webpack_public_path__ + "img/35.458eab8d.jpg";